import {Injectable} from '@angular/core';
import {MotorQuoteDTO} from '../../models/MotorQuoteDTO.interfaces';
import {PrivacyUser} from '../../enums/privacy-users';
import {BehaviorSubject, map} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrivacyService {
  private _privacyUser: PrivacyUser = PrivacyUser.NON_CONTITOLARE;
  private _privacyUser$: BehaviorSubject<PrivacyUser> = new BehaviorSubject<PrivacyUser>(
    PrivacyUser.NON_CONTITOLARE,
  );
  private _isSaveFlow: boolean = false;

  private formatPrivacyUserWithSaveFlow(privacyUser: PrivacyUser) {
    return privacyUser + (this._isSaveFlow ? '_SALVATAGGIO' : '');
  }
  getPrivacyUser() {
    return this.formatPrivacyUserWithSaveFlow(this._privacyUser);
  }
  getPrivacyUserAsObservable() {
    return this._privacyUser$
      .asObservable()
      .pipe(map((privacyUser) => this.formatPrivacyUserWithSaveFlow(privacyUser)));
  }
  setPrivacyUser(motorData: MotorQuoteDTO) {
    const isContitolare = motorData.response.configuration.agency.services?.ACC_DA == 3;
    this._privacyUser = isContitolare ? PrivacyUser.CONTITOLARE : PrivacyUser.NON_CONTITOLARE;
    this._privacyUser$.next(this._privacyUser);
  }
  setSaveFlow(status: boolean) {
    this._isSaveFlow = status;
    this._privacyUser$.next(this._privacyUser);
  }
}
